import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Tooltip } from '@paypalcorp/pp-react';

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".styles-module_checkbox_with_tooltip__-PLEI {\n  display: flex;\n  align-items: center;\n}\n.styles-module_pointer_events__oWspB {\n  pointer-events: none;\n}\n";
var styles = {"checkbox_with_tooltip":"styles-module_checkbox_with_tooltip__-PLEI","pointer_events":"styles-module_pointer_events__oWspB"};
styleInject(css_248z);

var _excluded = ["checkbox_content", "tooltip_content", "disabled"];
function DonateCheckbox(props) {
  var checkbox_content = props.checkbox_content,
    tooltip_content = props.tooltip_content,
    disabled = props.disabled,
    restProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(tooltip_content && styles.checkbox_with_tooltip, " ").concat(disabled && styles.pointer_events)
  }, /*#__PURE__*/React.createElement(Checkbox, _extends({
    label: checkbox_content,
    disabled: disabled !== null && disabled !== void 0 ? disabled : false
  }, restProps)), tooltip_content && /*#__PURE__*/React.createElement(Tooltip, {
    disabled: disabled !== null && disabled !== void 0 ? disabled : false,
    description: tooltip_content
  }));
}
DonateCheckbox.propTypes = {
  checkbox_content: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  tooltip_content: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  name: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  testid: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  onClick: PropTypes.func
};

export { DonateCheckbox };
